import React, { useEffect, useMemo, useState } from "react";
import StatutoryRatesManager from "../employee-management/salary-structure/StatutoryRatesManager.jsx";
import TdsReferenceHeadsManager from "../employee-management/salary-structure/TdsReferenceHeadsManager.jsx";
import {
  ActTabBar,
  TaxRegimeSidebar,
  STATUTORY_ACT_TABS,
} from "../employee-management/salary-structure/StatutoryActHistoryList.jsx";
import TdsEngineComplianceTab from "./TdsEngineComplianceTab";
import { Icon3dChecklist, Icon3dImportExport } from "../sidebar/Sidebar3dIcons";

const ALL_ACTS = ["pf", "esi", "pt", "gratuity", "tax", "tds", "fvu"];

/**
 * Payroll Settings → Statutory Rates and Reference Heads.
 * Act tabs: PF · ESI · PT · Gratuity · Tax Rates (Old/New sidebar) · TDS Reference Heads · TDS FVU Versions.
 */
export default function StatutoryRatesHeadsPanel({
  darkMode = false,
  canEdit = true,
  canViewTdsHeads = true,
  canViewTdsCompliance = true,
  initialAct = null,
}) {
  const tabs = useMemo(
    () => [
      ...STATUTORY_ACT_TABS,
      ...(canViewTdsHeads ? [{ id: "tds", label: "TDS Reference Heads", icon: Icon3dChecklist }] : []),
      ...(canViewTdsCompliance ? [{ id: "fvu", label: "TDS FVU Versions", icon: Icon3dImportExport }] : []),
    ],
    [canViewTdsHeads, canViewTdsCompliance]
  );
  const resolveAct = (act) => (tabs.some((t) => t.id === act) ? act : "pf");

  const [act, setAct] = useState(() => resolveAct(ALL_ACTS.includes(initialAct) ? initialAct : "pf"));
  const [taxRegime, setTaxRegime] = useState("old");

  useEffect(() => {
    if (initialAct && ALL_ACTS.includes(initialAct)) setAct(resolveAct(initialAct));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialAct]);

  // Keep Manager mounted (hidden on TDS/FVU) so one config load + drafts survive tab switches.
  const isStatutoryAct = STATUTORY_ACT_TABS.some((t) => t.id === act);
  const managerAct = isStatutoryAct ? act : "pf";

  return (
    <div className="space-y-4">
      <ActTabBar tabs={tabs} value={act} onChange={setAct} />

      <div className={isStatutoryAct ? (act === "tax" ? "flex items-start gap-5" : "") : "hidden"}>
        {act === "tax" && isStatutoryAct && (
          <TaxRegimeSidebar value={taxRegime} onChange={setTaxRegime} />
        )}
        <div className="min-w-0 flex-1">
          <StatutoryRatesManager
            key="statutory-rates-payroll-v3"
            focusedAct={managerAct}
            taxRegime={taxRegime}
            onTaxRegimeChange={setTaxRegime}
          />
        </div>
      </div>

      {act === "tds" && canViewTdsHeads && <TdsReferenceHeadsManager darkMode={darkMode} />}

      {act === "fvu" && canViewTdsCompliance && (
        <TdsEngineComplianceTab darkMode={darkMode} canEdit={canEdit} title="TDS FVU Versions" />
      )}
    </div>
  );
}
